<ion-toolbar class="main-header-toolbar">
    <app-student-header  *ngIf="this.isParentRole === false"></app-student-header>
    <app-header  *ngIf="this.isParentRole === true"></app-header>
</ion-toolbar>

<ion-content [fullscreen]="true" class="content">
    <!--refresher-->
    <ion-refresher class="ion-hide-sm-up" slot="fixed" [pullFactor]="0.5" [pullMin]="100"
    >
        <ion-refresher-content></ion-refresher-content>

    </ion-refresher>
    <!--refresher end-->


    <ion-grid fixed class="page-grid no-margin-top student-grid" [ngClass]="{'student-page ':this.isParentRole === false }" *transloco="let t; read: 'certificatePage'" >


        <app-semi-header  *ngIf="this.isParentRole === false" [title]="t('title') " [withShadow]="true" backPath="/certificates"
        ></app-semi-header>


        <ion-row class=" ion-no-padding study-content " [ngClass]="{'white-bg-wrapper ':this.isParentRole === true }" >
            <ion-col size="12" class="ion-no-margin ion-no-padding white-col">

                <div class="top-wrapper">

                    <div class="back" [routerLink]="'/study-history'"  *ngIf="this.isParentRole === true">
                        <img alt="back" src="assets/images/icons/arrow_left_green.svg"/>
                        {{ 'btnBack'|transloco }}
                    </div>

                    <div class="page-title"  *ngIf="this.isParentRole === true">
                        <div class="title-wrapper">
                            {{ t('title.parent') }}
                        </div>

                    </div>


                    <div class="certificate-download" [ngClass]="{'shadow ':this.isParentRole === true }">

                        <div class="certificate-save mobile" *ngIf="htmlSafe && isSmallScreen()">
                            <button type="button" (click)="download()" class="certificate-download-btn">  {{ t('save') }}
                            </button>
                        </div>


                        <div class="certificate-wrapper" [innerHTML]="htmlSafe"></div>

                        <div class="certificate-save"  *ngIf="htmlSafe">
                            <button type="button" (click)="download()" class="certificate-download-btn">{{ t('save') }}
                            </button>
                        </div>
                    </div>
                </div>
            </ion-col>


            <ion-col size="12" class="ion-no-margin ion-no-padding">

                <app-banners [banners]=""></app-banners>
            </ion-col>


        </ion-row>


        <app-chats></app-chats>


    </ion-grid>

    <app-footer></app-footer>

</ion-content>

